import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  Divider,
  Button,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { getSubdepartment } from "../../api/subDepartment-api";
import { CSSTransition } from "react-transition-group";
import "./index.css";
import Carousel from "react-elastic-carousel";
import { getAllDocuments } from "../../api/documentapi";

function SubDepartment() {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const { departmentData } = useSelector((state) => state.department);

  const { data: subDepartmentData } = useQuery({
    queryKey: ["subDepartments"],
    queryFn: async () => {
      const response = await getSubdepartment(departmentData?.id);
      console.log(response); // Check the response format
      return response;
    },
  });
  const { data: doucument, refetch } = useQuery({
    queryKey: ["documents", selectedDepartment?.id],
    queryFn: async () => {
      if (!selectedDepartment?.id) return [];
      const response = await getAllDocuments(selectedDepartment.id);
      return response;
    },
    enabled: !!selectedDepartment?.id,
  });
  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
  };
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];

  return (
    <>
      <Grid
        container
        py={10}
        sx={{ textAlign: "center", justifyContent: "center", pt: "12vh" }}
      >
        <Grid item xs={12}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                mb: 3,
              }}
            >
              {departmentData?.name || "Sub Department Title"}
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                textAlign: "center",
                mb: 3,
              }}
            >
              {departmentData?.description || "Sub Department Description"}
            </Typography>

            <Grid
              container
              alignItems="center"
              spacing={2}
              mb={5}
              justifyContent={"center"}
            ></Grid>

            <Carousel breakPoints={breakPoints}>
              {subDepartmentData?.length > 0 &&
                subDepartmentData?.map((subdepart, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      cursor: 'pointer',
                      padding: 2,
                      borderRadius: 2,
                      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                      transition: 'transform 0.3s',
                      '&:hover': {
                        transform: 'scale(1.05)',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                      },
                    }}
                    onClick={() => handleDepartmentClick(subdepart)}
                  >
                    <Avatar
                      variant="rounded"
                      sx={{
                        width: '15vw',
                        height: '10vh',
                        my: 1,
                      }}
                      src={subdepart.image || "/Departments/subdeparments/Typesofstrategic/linear strategic managemnt.png"}
                      alt={subdepart.name}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        color: selectedDepartment?.name === subdepart.name ? "#3f51b5" : "black",
                        fontWeight: 'bold',
                        textAlign: 'center',
                      }}
                    >
                      {subdepart.name}
                    </Typography>
                  </Box>
                ))}
            </Carousel>
          </Box>
        </Grid>

        <CSSTransition
          in={Boolean(selectedDepartment)}
          timeout={300}
          classNames="slide"
          unmountOnExit
        >
          <Grid item xs={12}>
            {/* Department Details */}

            <Typography
              variant="h4"
              component="div"
              sx={{ fontWeight: "bold", textAlign: "center", color: "#3f51b5" }}
            >
              {selectedDepartment?.name}
            </Typography>
            <Grid
              container
              justifyContent={"center"}
              sx={{
                backgroundImage:
                  "url(/Departments/subdeparments/bgimageforsubdeparmennt.jpg)",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                width: "86vw",
                ml: "2vw",
                height: "auto",
                py: "3vh",
              }}
            >
              <Grid item md={3} mt={"-1vh"}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Avatar
                    src={selectedDepartment?.iconImage || "/Departments/subdeparments/Typesofstrategic/linear strategic managemnt.png"}
                    alt={selectedDepartment?.name}
                    sx={{ height: "auto", width: "5vw" }}
                    variant="square"
                  />

                </Box>
                <Typography
                  variant="h4"
                  sx={{
                    textAlign: "center",
                    fontWeight: "bold",
                    color: "#3f51b5",
                  }}
                >
                  {selectedDepartment?.name}
                </Typography>
                <Box
                  sx={{ display: "flex", justifyContent: "center" }}
                  my={"1vh"}
                >
                  <Divider sx={{ border: "2px solid #2C92BF", width: "8vw" }} />
                </Box>
                <Typography
                  variant="h4"
                  sx={{ fontSize: "1vw", textAlign: "center" }}
                >
                  {selectedDepartment?.description}
                </Typography>
              </Grid>

              <Grid
                item
                md={8}
                height={"20vh"}
                pt={"4.3vh"}
                sx={{ borderLeft: "6px double #3f51b5", pl: "2vw" }}
              >
                <Typography
                  variant="h3"
                  mb={"2vh"}
                  sx={{
                    fontSize: "2vw",
                    fontWeight: "bold",
                    textAlign: "center",
                    color: "#3f51b5",
                  }}
                >
                  {selectedDepartment?.name}
                </Typography>
                <Typography variant="h4" sx={{ fontSize: "1vw" }}>
                  {selectedDepartment?.definition}
                </Typography>
              </Grid>
            </Grid>

            <Typography
              variant="h2"
              textAlign={"center"}
              sx={{
                fontSize: "2vw",
                color: "#3f51b5",
                fontWeight: "bold !important",
              }}
              my={"5vh"}
            >
              Types Of {selectedDepartment?.name}
            </Typography>

            <Grid
              container
              sx={{ width: "85vw", gap: "1vw" }}
              justifyContent={"center"}
              mt={"3vh"}
              mb={"4vh"}
              ml={"1vw"}
            >
              {doucument?.length > 0 ? (
                doucument?.map((document, index) => (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    sm={6}
                    md={3.8}
                    sx={{ display: "flex" }}
                  >
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: "22vw",
                        height: "auto",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                    >
                      {/* Icon Image */}
                      <Avatar
                        variant="square"
                        src={selectedDepartment?.iconImage || "/Departments/subdeparments/Typesofstrategic/linear strategic managemnt.png"}
                        sx={{ width: "4vw", height: "auto", mb: "1.5vh" }}
                        alt={document.title}
                      />

                      {/* Document Details */}
                      <CardContent>
                        <Typography
                          variant="h3"
                          sx={{ fontSize: "1.5vw", textAlign: "center" }}
                        >
                          {document.title}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ fontSize: "1vw", textAlign: "center", mt: "1vh" }}
                        >
                          {document.description}
                        </Typography>


                        <Box mt={2} textAlign="center">
                          {selectedDepartment.pdfUrl && (
                            <>
                              {/* View PDF Button */}
                              <Button
                                variant="outlined"
                                sx={{ mr: 1 }}
                                href={selectedDepartment.pdfUrl}  // Correct PDF URL
                                target="_blank"
                              >
                                View PDF
                              </Button>

                              {/* Download PDF Button using <a> tag */}
                              <a
                                href={selectedDepartment.pdfUrl}  // Correct PDF URL for download
                                download  // This will trigger the download
                                style={{ textDecoration: 'none' }}  // Styling to match button appearance
                              >
                                <Button variant="contained">
                                  Download PDF
                                </Button>
                              </a>
                            </>
                          )}
                        </Box>

                      </CardContent>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Typography variant="h6" textAlign="center">
                  No documents available for this sub-department.
                </Typography>
              )}

            </Grid>

          </Grid>
        </CSSTransition>
      </Grid>
    </>
  );
}

export default SubDepartment;
